import pick from 'lodash/pick';
import { USER_TYPES } from '../../../auth/constants';

const fields = [
  'username',
  'kind',
  'isTmpPassword',
];

// eslint-disable-next-line import/prefer-default-export
export const prepareApiUpdate = (data, brandId) => {
  const model = pick(data, fields);
  const isBrandType = parseInt(data.kind, 10) === USER_TYPES.brand;

  model.kind = USER_TYPES.shop;

  if (data.shopIds) {
    model.shopIds = data.shopIds.map(shop => ({
      id: shop,
      permissions: data.permissions,
    }));
  }
  if (isBrandType) {
    model.brand = {
      id: brandId,
      permissions: data.permissions,
    };
  }

  return model;
};
